export const INERT_CSS_CLASSES =
  "relative before:absolute before:bg-white before:opacity-50 before:top-0 before:left-0 before:bottom-0 before:right-0 before:z-10 before:content-['']";

/**
 * Simple helper to handle adding and removing the non-standard `inert` HTML attribute to a JSX element.
 * JSX doens't support the `inert` attribute (yet), so we have to use this helper to add and remove it
 * until `inert` is a standard attribute.
 *
 * Also passes back an inert styling and inert state to optionally be used in the component.
 *
 * The attribute has really good browser support, but it's just not standard yet.
 * @see https://caniuse.com/?search=inert
 *
 * @param ref - React ref to the element to add the inert attribute to
 * @param isInert - Whether to add or remove the inert attribute
 */
export const makeInert = ({
  isInert = false,
  ref,
}: {
  isInert?: boolean;
  ref: React.RefObject<HTMLElement>;
}) => {
  if (ref.current) {
    if (isInert && !ref.current.hasAttribute("inert")) {
      ref.current.setAttribute("inert", "true");
    } else if (!isInert && ref.current.hasAttribute("inert")) {
      ref.current.removeAttribute("inert");
      return {
        isInert,
        inertCssClass: null,
      };
    }
  }

  return {
    isInert,
    // we always want to pass back the inert styles, regardless of the ref being present or not.
    inertCssClass: isInert ? INERT_CSS_CLASSES : null,
  };
};
